import { useQuery, useQueryClient } from '@tanstack/react-query';

import backendService from '../services/backendService';
import { Game } from '../services/backendService/types';
import { gameCacheKey } from './useGame';

export const gamePinCacheKey = 'game-pin';

function useGenerateNewGamePin(gameId?: string, pin?: string | null) {
  const client = useQueryClient();
  const { data, isFetching } = useQuery<Game | undefined>(
    [gamePinCacheKey, gameId],
    _ => {
      if (!gameId) return Promise.resolve(undefined);
      if (pin) return Promise.resolve(undefined);
      return backendService.instance.game.generateNewPin(gameId);
    },
    {
      enabled: Boolean(gameId) && !pin,
      onSettled: game => {
        if (game) {
          client.setQueryData<Game | undefined>([gameCacheKey, gameId], oldGame =>
            oldGame
              ? {
                  ...oldGame,
                  pin: game.pin,
                }
              : oldGame,
          );
        }
      },
    },
  );

  return {
    pin: data?.pin,
    isFetching,
  };
}

export default useGenerateNewGamePin;
